import React from "react";
import DarkModeToggler from "../darkModeToggler/DarkModeToggler";

const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
  const borderY = 2;
  const offset = borderY;

  e.currentTarget.style.height = "auto";
  e.currentTarget.style.height = e.currentTarget.scrollHeight + offset + "px";
};

const Expandable = () => {
  return (
    <div className="my-20">
      <h1 className="mb-5 text-3xl">This is auto extendable textarea</h1>
      <div>
        <DarkModeToggler />
      </div>

      <textarea
        rows={1}
        placeholder="Write something nice..."
        spellCheck={false}
        onChange={handleChange}
        style={{
          padding: 15
        }}
        className={`bg-transparent outline-none text-4xl text-gray-600 
          font-bold resize-none border rounded-xl box-border
          dark:bg-gray-700 dark:text-gray-200 transition-colors duration-500
        `}
      />
    </div>
  );
};

export default Expandable;
